import { jsx } from 'react/jsx-runtime';
import { StyledCell } from './styles.js';
import { ButtonPrimary } from '../ButtonPrimary/index.js';
import { ButtonSecondary } from '../ButtonSecondary/index.js';

const CellModalButton = ({
  buttonText,
  hasPrimaryButton,
  onClick,
  ...props
}) => {
  const CellButton = hasPrimaryButton ? ButtonPrimary : ButtonSecondary;
  return jsx(StyledCell, Object.assign({
    divider: "top"
  }, props, {
    children: jsx(CellButton, Object.assign({
      isFullWidth: true,
      onClick: onClick
    }, {
      children: buttonText
    }), void 0)
  }), void 0);
};
CellModalButton.displayName = 'CellModalButton';

export { CellModalButton };
